export default __webpack_public_path__ + "static/media/nearby.01a4bc0c.png";